import { render, staticRenderFns } from "./SkillTree.vue?vue&type=template&id=d8f6c16a&scoped=true&"
import script from "./SkillTree.vue?vue&type=script&lang=ts&"
export * from "./SkillTree.vue?vue&type=script&lang=ts&"
import style0 from "./SkillTree.vue?vue&type=style&index=0&id=d8f6c16a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f6c16a",
  null
  
)

export default component.exports